import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { InsuranceService } from '@APP/services/insurance-service';
import { QuestionsService } from '@APP/services/questions-service';
import { t } from '@APP/utils/locale';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { GoodMessage } from '../icons/icons';

type deps = {
  insuranceService: InsuranceService;
  questionsService: QuestionsService;
};
@requires(QuestionsService.serviceName, InsuranceService.serviceName)
@customElement('mta-complete-popup')
export class NonEligablePopup extends DepInjMixin<deps>(DeviceAwareComponent) {
  static get styles() {
    return [
      commonPopupStyle,
      css`
         .title{
         font-weight:700;
         font-size:4rem;
       margin-bottom:1.75rem;
      }
      .sub-title{
        font-size: 4rem;
        font-weight: 700;
        margin-bottom: 0;
        max-width:61.375rem;
        color: var(--c-text-sub);
      }
      .message{
        margin:0;
        max-width:53.25rem;
        color: var(--c-text);
       } 
       
      svg, img{
        max-width: 26.5rem;
        max-height: 36.5rem;
      }
       `,
    ];
  };

  static get mobileStyles() {
    return [commonPopupMobileStyle];
  }

  renderMobileLayout() {
    return html`
      <div class="grid-container">
       <div class="col-1">
        <h1 class="title">${t('T_MTA_Complete_1')}</h1>
        <h2 class="message">${t('T_MTA_Complete_2')}</h2>
       </div>
       <div class="col-2">
        ${GoodMessage}
      </div>
      <div class="col-3"></div>
     </div>
    `;
  }

  renderDesktopLayout() {
    return html`
      <div class="grid-container">
       <div class="col-1"></div>
       <div class="col-2 min-height">
        <h1 class="title">${t('T_MTA_Complete_1')}</h1>
        <h2 class="message">${t('T_MTA_Complete_2')}</h2>
      </div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
